// Server-safe glass tokens. glass-kit.tsx is a client module, so route files
// (server components) can't read THEME from it; the canvas colour lives here.
export const GLASS_DARK_BG = "#050506"
export const GLASS_LIGHT_BG = "#EFEDE7"
